import {Modal, Button} from "antd";
import {CheckOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import config from "@/config";
import "@/pages/a.css";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay} from "swiper/modules"

const LoginPopup = ({visible, onClose}) => {
    const navigate = useNavigate();
    const content = (
        <div className={"p-4 w-full"}>
            <div className="lg:flex justify-between hidden gap-4 relative">
                {/* Ứng viên */}
                <div className="w-1/2 p-4 min-h-[200px] shadow-lg rounded-xl bg-white text-center">
                    <div className="w-24 h-24 mx-auto -mt-16 mb-4">
                        <img src="/img/logo.jpg" alt="Tìm kiếm việc làm"
                             className="w-full h-full object-cover rounded-full"/>
                    </div>
                    <ul className="text-left mb-4 space-y-2">
                        <li className="flex items-center gap-2">
                            <CheckOutlined className="text-black font-bold"/> Công việc thường xuyên cập nhật
                        </li>
                        <li className="flex items-center">
                            <CheckOutlined className="text-black font-bold"/>
                            <p className={"ms-2"}>Ứng tuyển công việc yêu thích<span
                                className={"text-red-500 font-bold"}> HOÀN TOÀN MIỄN PHÍ</span></p>
                        </li>
                        <li className="flex items-center gap-2">
                            <CheckOutlined className="text-black font-bold"/> Hiển thị thông tin hồ sơ với nhà tuyển
                            dụng hàng đầu
                        </li>
                        <li className="flex items-center gap-2">
                            <CheckOutlined className="text-black font-bold"/> Nhận bản tin công việc phù hợp định kỳ
                        </li>
                    </ul>
                    <Button type="primary" block className="bg-blue-500 text-white font-bold py-2 rounded">
                        Đăng ký ứng viên
                    </Button>
                </div>
                {/* Nhà tuyển dụng */}
                <div className="w-1/2 p-4 min-h-[200px] shadow-lg rounded-xl bg-white text-center">
                    <div className="w-24 h-24 mx-auto -mt-16 mb-4">
                        <img src="/img/logo.jpg" alt="Nhà tuyển dụng"
                             className="w-full h-full object-cover rounded-full"/>
                    </div>
                    <ul className="text-left mb-4 space-y-2">
                        <li className="flex items-center gap-2">
                            <CheckOutlined className="text-black font-bold"/> Ứng viên sẵn sàng tiếp cận thông tin tuyển
                            dụng
                        </li>
                        <li className="flex items-center gap-2">
                            <CheckOutlined className="text-black font-bold"/> Không giới hạn tương tác với ứng viên trên
                            hệ thống
                        </li>
                        <li className="flex items-center gap-2">
                            <CheckOutlined className="text-black font-bold"/> Quảng cáo thông minh giúp tin tuyển dụng
                            phủ rộng trên toàn bộ hệ thống
                        </li>
                    </ul>
                    <Button type="primary" block onClick={() => {
                        navigate(config.routes.createApplyLists)
                    }} className="bg-blue-500 text-white font-bold py-2 rounded">
                        Đăng ký nhà tuyển dụng
                    </Button>
                </div>
            </div>
            <Swiper
                className={"lg:!hidden"}
                modules={[Autoplay]}
                loop={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                }}
                spaceBetween={50}
                slidesPerView={1}
            >
                <SwiperSlide>
                    <div className="p-4 min-h-[200px] shadow-lg rounded-xl bg-white text-center">
                        <ul className="text-left mb-4 space-y-2">
                            <li className="flex items-center gap-2">
                                <CheckOutlined className="text-black font-bold"/> Công việc thường xuyên cập nhật
                            </li>
                            <li className="flex items-center">
                                <CheckOutlined className="text-black font-bold"/>
                                <p className={"ms-2"}>Ứng tuyển công việc yêu thích<span
                                    className={"text-red-500 font-bold"}> HOÀN TOÀN MIỄN PHÍ</span></p>
                            </li>
                            <li className="flex items-center gap-2">
                                <CheckOutlined className="text-black font-bold"/> Hiển thị thông tin hồ sơ với nhà tuyển
                                dụng hàng đầu
                            </li>
                            <li className="flex items-center gap-2">
                                <CheckOutlined className="text-black font-bold"/> Nhận bản tin công việc phù hợp định kỳ
                            </li>
                        </ul>
                        <Button type="primary" block className="bg-blue-500 text-white font-bold py-2 rounded">
                            Đăng ký ứng viên
                        </Button>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="p-4 min-h-[200px] shadow-lg rounded-xl bg-white text-center">
                        <ul className="text-left mb-4 space-y-2">
                            <li className="flex items-center gap-2">
                                <CheckOutlined className="text-black font-bold"/> Ứng viên sẵn sàng tiếp cận thông tin
                                tuyển dụng
                            </li>
                            <li className="flex items-center gap-2">
                                <CheckOutlined className="text-black font-bold"/> Không giới hạn tương tác với ứng viên
                                trên hệ thống
                            </li>
                            <li className="flex items-center gap-2">
                                <CheckOutlined className="text-black font-bold"/> Quảng cáo thông minh giúp tin tuyển
                                dụng phủ rộng trên toàn bộ hệ thống
                            </li>
                        </ul>
                        <Button type="primary" block onClick={() => {
                            navigate(config.routes.createApplyLists)
                        }} className="bg-blue-500 text-white font-bold py-2 rounded">
                            Đăng ký nhà tuyển dụng
                        </Button>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    )
    return (
        <div className={"w-full flex-wrap flex items-center p-4"}>
            <Modal
                open={visible}
                onCancel={onClose}
                footer={null}
                centered
                width={800}
                wrapClassName="custom-modal"
            >
                {content}
            </Modal>
        </div>
    );
};

export default LoginPopup;